var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotDoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 200,
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 163.3H176.9C181.6 163.3 186.1 161.4 189.4 158.1L302.7 44.5C305.5 41.7 303.5 37 299.6 37H133.8C131.5 37 129.2 37.9 127.6 39.6L18.6 148.2C13.1 153.8 17 163.3 24.8 163.3Z",
    fill: "#E8EFF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 66.1016L72.6001 78.1016V99.5016L86.4001 106.402V101.502L77.9001 95.7016V82.3016L103.1 74.0016",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.1 68.5L74.6001 79.5L74.7001 98.3L86.4001 104.6L86.5001 101.3L77.9001 95.7V82.3L103.1 74V68.5Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 66.1016L72.6001 78.1016V99.5016L86.4001 106.402V101.502L77.9001 95.7016V82.3016L103.1 74.0016",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.2 98.4992V127.799H82.6001V89.1992H140.2V98.4992Z",
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.8 91.8984H85.8V126.781H125.8V91.8984Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 89.3008V99.5008L100.5 98.7008L102 99.5008L103.5 98.7008L105 99.5008L106.5 98.7008L108 99.5008L109.5 98.7008L111 99.5008V89.3008H99Z",
    fill: "#FFD65A",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 119.699H88.6001V120.999H108.8V119.699Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7001 122.801H88.6001V124.101H98.7001V122.801Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 92H125.8V126.784H137.5V92Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 98.3984H134.2V109.398H137.5V98.3984Z",
    fill: "#FFD65A",
    stroke: "#220C4A",
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 62L110 28L112 28L112 62L110 62Z",
    fill: "#220C4A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 66.1016L150 78.1016V99.5016L136.1 106.402V101.502L144.6 95.7016V82.3016L119.4 74.0016",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.4 68.5L147.9 79.5L147.8 98.3L136.1 104.6L136 101.3L144.6 95.7V82.3L119.4 74V68.5Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 66.1016L150 78.1016V99.5016L136.1 106.402V101.502L144.6 95.7016V82.3016L119.4 74.0016",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 62.3008H103.3V77.7008H119.5V62.3008Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.2 65H103V77.8H119.2V65Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 62.3008H103.3V77.7008H119.5V62.3008Z",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.4 72.5C112.8 72.5 113.9 71.4 113.9 70C113.9 68.6 112.8 67.5 111.4 67.5C110 67.5 108.9 68.6 108.9 70C108.9 71.4 110 72.5 111.4 72.5Z",
    fill: "#666666",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45.3008L104.9 52.4008H111.3H117.6L124.5 45.3008",
    fill: "#B8B8B8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45.3008L104.9 52.4008H111.3H117.6L124.5 45.3008",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2659 32H124.226V44.9848H98.2659V32Z",
    fill: "#E0E0E0",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.7 52.3984H107.8V55.5984H114.7V52.3984Z",
    fill: "#666666",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M125.8 28.1211H96.8V32.0002H125.8V28.1211Z",
    fill: "#666666",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M244.5 126.402V155.702H186.9V117.102H244.5V126.402Z",
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M230.1 119.801H190.1V155.201H230.1V119.801Z",
    fill: "#F5F5F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.3 117.203V127.403L204.8 126.603L206.3 127.403L207.8 126.603L209.3 127.403L210.8 126.603L212.3 127.403L213.8 126.603L215.3 127.403V117.203H203.3Z",
    fill: "#2CE27E",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M213.1 147.602H192.9V148.902H213.1V147.602Z",
    fill: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203 150.703H192.9V152.003H203V150.703Z",
    fill: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M241.8 119.902H230.1V155.202H241.8V119.902Z",
    fill: "#E0E0E0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M270.7 175.499H48.9C43.4 175.499 39 171.099 39 165.599C39 160.099 43.4 155.699 48.9 155.699H270.7C276.2 155.699 280.6 160.099 280.6 165.599C280.6 171.099 276.2 175.499 270.7 175.499Z",
    fill: "#C4F4FE",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M270.8 170.199H48.7001C46.3001 170.199 44.3 168.199 44.3 165.699C44.3 163.199 46.3001 161.199 48.7001 161.199H270.9C273.3 161.199 275.3 163.199 275.3 165.699C275.2 168.199 273.3 170.199 270.8 170.199Z",
    fill: "#13D2FC",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 167.298C58.3 167.298 59 166.598 59 165.698C59 164.798 58.3 164.098 57.5 164.098C56.7 164.098 56 164.798 56 165.698C56 166.598 56.7 167.298 57.5 167.298Z",
    fill: "#03B3D9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3001 167.298C66.1001 167.298 66.8001 166.598 66.8001 165.698C66.8001 164.798 66.1001 164.098 65.3001 164.098C64.5001 164.098 63.8 164.798 63.8 165.698C63.8 166.598 64.5001 167.298 65.3001 167.298Z",
    fill: "#03B3D9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 167.298C74 167.298 74.7 166.598 74.7 165.698C74.7 164.798 74 164.098 73.2 164.098C72.4 164.098 71.7 164.798 71.7 165.698C71.7 166.598 72.4 167.298 73.2 167.298Z",
    fill: "#03B3D9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1001 167.298C81.9001 167.298 82.6001 166.598 82.6001 165.698C82.6001 164.798 81.9001 164.098 81.1001 164.098C80.3001 164.098 79.6001 164.798 79.6001 165.698C79.6001 166.598 80.3001 167.298 81.1001 167.298Z",
    fill: "#03B3D9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M89 167.298C89.8 167.298 90.5 166.598 90.5 165.698C90.5 164.798 89.8 164.098 89 164.098C88.2 164.098 87.5 164.798 87.5 165.698C87.5 166.598 88.2 167.298 89 167.298Z",
    fill: "#03B3D9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8999 167.298C97.6999 167.298 98.3999 166.598 98.3999 165.698C98.3999 164.798 97.6999 164.098 96.8999 164.098C96.0999 164.098 95.3999 164.798 95.3999 165.698C95.3999 166.598 96.0999 167.298 96.8999 167.298Z",
    fill: "#03B3D9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 167.298C105.6 167.298 106.3 166.598 106.3 165.698C106.3 164.798 105.6 164.098 104.8 164.098C104 164.098 103.3 164.798 103.3 165.698C103.3 166.598 104 167.298 104.8 167.298Z",
    fill: "#03B3D9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.6 167.298C113.4 167.298 114.1 166.598 114.1 165.698C114.1 164.798 113.4 164.098 112.6 164.098C111.8 164.098 111.1 164.798 111.1 165.698C111.1 166.598 111.8 167.298 112.6 167.298Z",
    fill: "#03B3D9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 167.298C121.3 167.298 122 166.598 122 165.698C122 164.798 121.3 164.098 120.5 164.098C119.7 164.098 119 164.798 119 165.698C119 166.598 119.7 167.298 120.5 167.298Z",
    fill: "#03B3D9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M128.4 167.298C129.2 167.298 129.9 166.598 129.9 165.698C129.9 164.798 129.2 164.098 128.4 164.098C127.6 164.098 126.9 164.798 126.9 165.698C126.9 166.598 127.6 167.298 128.4 167.298Z",
    fill: "#03B3D9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M136.3 167.298C137.1 167.298 137.8 166.598 137.8 165.698C137.8 164.798 137.1 164.098 136.3 164.098C135.5 164.098 134.8 164.798 134.8 165.698C134.8 166.598 135.5 167.298 136.3 167.298Z",
    fill: "#03B3D9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M144.2 167.298C145 167.298 145.7 166.598 145.7 165.698C145.7 164.798 145 164.098 144.2 164.098C143.4 164.098 142.7 164.798 142.7 165.698C142.7 166.598 143.4 167.298 144.2 167.298Z",
    fill: "#03B3D9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M152.1 167.298C152.9 167.298 153.6 166.598 153.6 165.698C153.6 164.798 152.9 164.098 152.1 164.098C151.3 164.098 150.6 164.798 150.6 165.698C150.6 166.598 151.3 167.298 152.1 167.298Z",
    fill: "#03B3D9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M160 167.298C160.8 167.298 161.5 166.598 161.5 165.698C161.5 164.798 160.8 164.098 160 164.098C159.2 164.098 158.5 164.798 158.5 165.698C158.5 166.598 159.2 167.298 160 167.298Z",
    fill: "#03B3D9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M167.8 167.298C168.6 167.298 169.3 166.598 169.3 165.698C169.3 164.798 168.6 164.098 167.8 164.098C167 164.098 166.3 164.798 166.3 165.698C166.3 166.598 167 167.298 167.8 167.298Z",
    fill: "#03B3D9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M175.7 167.298C176.5 167.298 177.2 166.598 177.2 165.698C177.2 164.798 176.5 164.098 175.7 164.098C174.9 164.098 174.2 164.798 174.2 165.698C174.2 166.598 174.9 167.298 175.7 167.298Z",
    fill: "#03B3D9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M183.6 167.298C184.4 167.298 185.1 166.598 185.1 165.698C185.1 164.798 184.4 164.098 183.6 164.098C182.8 164.098 182.1 164.798 182.1 165.698C182.1 166.598 182.8 167.298 183.6 167.298Z",
    fill: "#03B3D9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 167.298C192.3 167.298 193 166.598 193 165.698C193 164.798 192.3 164.098 191.5 164.098C190.7 164.098 190 164.798 190 165.698C190 166.598 190.7 167.298 191.5 167.298Z",
    fill: "#03B3D9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.4 167.298C200.2 167.298 200.9 166.598 200.9 165.698C200.9 164.798 200.2 164.098 199.4 164.098C198.6 164.098 197.9 164.798 197.9 165.698C197.9 166.598 198.6 167.298 199.4 167.298Z",
    fill: "#03B3D9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M207.3 167.298C208.1 167.298 208.8 166.598 208.8 165.698C208.8 164.798 208.1 164.098 207.3 164.098C206.5 164.098 205.8 164.798 205.8 165.698C205.8 166.598 206.5 167.298 207.3 167.298Z",
    fill: "#03B3D9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M215.2 167.298C216 167.298 216.7 166.598 216.7 165.698C216.7 164.798 216 164.098 215.2 164.098C214.4 164.098 213.7 164.798 213.7 165.698C213.7 166.598 214.4 167.298 215.2 167.298Z",
    fill: "#03B3D9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M223 167.298C223.8 167.298 224.5 166.598 224.5 165.698C224.5 164.798 223.8 164.098 223 164.098C222.2 164.098 221.5 164.798 221.5 165.698C221.5 166.598 222.2 167.298 223 167.298Z",
    fill: "#03B3D9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9 167.298C231.7 167.298 232.4 166.598 232.4 165.698C232.4 164.798 231.7 164.098 230.9 164.098C230.1 164.098 229.4 164.798 229.4 165.698C229.4 166.598 230.1 167.298 230.9 167.298Z",
    fill: "#03B3D9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M238.8 167.298C239.6 167.298 240.3 166.598 240.3 165.698C240.3 164.798 239.6 164.098 238.8 164.098C238 164.098 237.3 164.798 237.3 165.698C237.3 166.598 238 167.298 238.8 167.298Z",
    fill: "#03B3D9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M246.7 167.298C247.5 167.298 248.2 166.598 248.2 165.698C248.2 164.798 247.5 164.098 246.7 164.098C245.9 164.098 245.2 164.798 245.2 165.698C245.2 166.598 245.9 167.298 246.7 167.298Z",
    fill: "#03B3D9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M254.6 167.298C255.4 167.298 256.1 166.598 256.1 165.698C256.1 164.798 255.4 164.098 254.6 164.098C253.8 164.098 253.1 164.798 253.1 165.698C253.1 166.598 253.8 167.298 254.6 167.298Z",
    fill: "#03B3D9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 167.298C263.3 167.298 264 166.598 264 165.698C264 164.798 263.3 164.098 262.5 164.098C261.7 164.098 261 164.798 261 165.698C261 166.598 261.7 167.298 262.5 167.298Z",
    fill: "#03B3D9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 168.101C50.8 168.101 51.7999 167.001 51.7999 165.701C51.7999 164.401 50.8 163.301 49.5 163.301C48.2 163.301 47.2 164.401 47.2 165.701C47.2 167.001 48.2 168.101 49.5 168.101Z",
    fill: "#03B3D9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M270.4 168.101C271.7 168.101 272.7 167.001 272.7 165.701C272.7 164.401 271.7 163.301 270.4 163.301C269.1 163.301 268.1 164.401 268.1 165.701C268.1 167.001 269.1 168.101 270.4 168.101Z",
    fill: "#03B3D9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M198.7 44.8008L181.1 90.0008L229.1 82.6008L198.7 44.8008Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M199.6 50.9023L184.9 89.0023L225.2 82.8023L199.6 50.9023Z",
    fill: "#FF3A37"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M198.7 44.8008L181.1 90.0008L229.1 82.6008L198.7 44.8008Z",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M203.544 63.0444L204.444 72.2444C204.444 73.0444 204.044 73.7444 203.244 73.8444C202.444 74.0444 201.744 73.5444 201.444 72.7444L199.044 63.8444C198.844 63.2444 199.344 62.4444 200.044 62.3444L202.244 62.0444C203.044 61.8444 203.644 62.3444 203.544 63.0444Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M201.744 78.7434C202.344 79.8434 203.744 80.3434 204.844 79.7434C205.944 79.1434 206.444 77.7434 205.844 76.6434C205.244 75.5434 203.844 75.0434 202.744 75.6434C201.644 76.2434 201.244 77.6434 201.744 78.7434Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 80C239.7 83.2 238.7 87.4 235.5 89.4",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M234.7 81C235.9 82.9 235.3 85.5 233.4 86.7",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M178.6 98.4016C174.9 98.1016 172 94.9016 172.3 91.1016",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M179.5 95.3023C177.2 95.1023 175.5 93.2023 175.7 90.9023",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotDoneIcon);
export default __webpack_public_path__ + "static/media/not-done-icon.a0c563e5773df2cabdb20d55626609a5.svg";
export { ForwardRef as ReactComponent };